import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectors, constants } from '@yola/subscription-manager-js';
import routesMap from 'src/js/router/helpers/routes-map';
import dialogs from 'src/js/modules/dialogs';
import isDifmOrderSubmitted from 'src/js/modules/difm/verifiers/is-difm-order-submitted';

const { SubscriptionType } = constants;

const DifmUpsellRoute = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentPlanType = useSelector(selectors.getCurrentPackageType);

  useEffect(() => {
    navigate(routesMap.home.url(), {
      replace: true,
      state: {
        isCloseModalOnRouteChange: false,
      },
    });

    if (currentPlanType !== SubscriptionType.B2C_HOSTING_GOLD && !isDifmOrderSubmitted()) {
      dispatch(dialogs.actions.show(dialogs.dialogTypes.DIFM_UPSELL_DIALOG));
    }
  }, [dispatch, currentPlanType, navigate]);

  return null;
};

export default DifmUpsellRoute;
